/* jshint esversion: 6, -W097 */
/* globals module */
'use strict';

/**
 * Creates an product card tags instance
 *
 * @module enervee_utils.product_card
 */
function productCardTagsDirective() {
    return {
        restrict: 'E',
        scope: {
            product: '='
        },
        controller: productCardTagsController,
        template: require('./tagsView.html')
    };
}

productCardTagsController.$inject = ['$scope', 'UtilService'];
function productCardTagsController ($scope, UtilService) {
    $scope.showGreenButton = UtilService.isFeatureEnabled('show_green_button');

    if ('tags_json' in $scope.product) {
        $scope.product.tags = $scope.product.tags_json;
        if (!$scope.showGreenButton) {
            var tagsToShow = [];
            $scope.product.tags.forEach(function (tag) {
                if (tag.key !== 'green-button-alliance') {
                    tagsToShow.push(tag);
                }
            });
            $scope.product.tags = tagsToShow;
        }
    }
}

module.exports = productCardTagsDirective;
